"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M15.8058 12.3184H20.694L14.1347 19.0001H7.33398",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), (0, jsx_runtime_1.jsx)("ellipse", {
      cx: "6.71445",
      cy: "13.079",
      rx: "5.71445",
      ry: "5.92099",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("ellipse", {
      cx: "6.85307",
      cy: "13.0789",
      rx: "2.6851",
      ry: "2.61625",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11.1212 16.8657L15.7065 12.3909C17.9876 10.1098 17.9876 6.41141 15.7065 4.13031C13.4254 1.8492 9.72697 1.8492 7.44586 4.13031L2.58399 9.01693",
      stroke: "currentColor",
      strokeWidth: "1.2"
    })]
  });
};

exports.default = Icon;